const styles = () => ({
	container: {
		display: 'flex',
		flexFlow: 'row wrap',
		justifyContent: 'flex-start',
		width: '87.5%',
		marginLeft: 'auto',
		marginRight: 'auto'
	},
	'@media (max-width: 940px)': {
		container: {
			justifyContent: 'space-between'
		}
	},
	'@media (min-width: 940px)': {
		container: {
			width: '95%'
		}
	}
});

export default styles;




// WEBPACK FOOTER //
// ./src/client/components/main/collections/list/styles.js